import {
    SYSTEM_CHOOSE_CURRENT_SALARYTYPE,
} from './constants';
  
export function chooseCurrentSalaryType(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_SALARYTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_SALARYTYPE:
        return {
          ...state,
          currentSalaryType:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentSalaryType.js